/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { colors } from '@lmc/common/constants'
import React, { CSSProperties } from 'react'
import Icon from '../../atoms/Icon'
import InputDatePicker from '../InputDatePicker'
import InputRadioGroup from '../InputRadioGroup'
import { DatePickerProps, Input, Row } from 'antd'
import styled from 'styled-components'

export type NextReviewFieldProps = {
  localisation?: { title: string; additionalInfo?: string; datePicker?: string }
  timeOptions: Array<{ value: string; label: string }>
  additionalInfo?: boolean
  dateValue?: string
  additionalInfoValue?: string
  timeValue?: string
  datePickerOnChange?: any
  radioGroupOnChange?: any
  textAreaOnChange?: any
  isMobile?: boolean
  format?: string
  disabledDate?: DatePickerProps['disabledDate']
}

const InputRadioGroupStyled = styled(InputRadioGroup)`
  .ant-radio-group {
    display: flex;
    flex-direction: row;
    margin-top: 15px;
  }

  .ant-radio-wrapper {
    margin: 0;
  }
`

const MainContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  width: 100%;
`
const NextReview = styled.div`
  font-weight: 700;

  ${({ theme }) => theme.mediaQueries.mobileDown} {
    margin-top: 8px;
  }
`
const CalendarIcon = styled(Icon)`
  font-size: 24px;
  margin: 10px;
  margin-left: 20px;
  margin-right: 20px;
  transform: 'translateY(5px)';
  display: 'inline-block';
`

const DateContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
`

const NextReviewField = ({
  localisation,
  dateValue,
  timeOptions,
  additionalInfo,
  additionalInfoValue,
  timeValue,
  datePickerOnChange,
  radioGroupOnChange,
  textAreaOnChange,
  format,
  disabledDate,
}: NextReviewFieldProps) => {
  const styles = {
    container: {
      display: 'flex',
      borderRadius: 15,
      background: colors.white,
      padding: 24,
      marginBottom: 24,
    },
    additionalInfo: {
      fontWeight: 700,
      marginBottom: 10,
    },
    textArea: {
      marginLeft: 'auto',
      marginRight: 'auto',
      marginBottom: 20,
      width: '100%',
    },
    datePicker: { marginRight: 10, marginTop: 15 },
    textAreaWrapper: {
      display: 'flex',
      width: '100%',
      flexDirection: 'column',
      marginTop: '10px',
    },
    radiosWrapper: {
      display: 'flex',
    },
  }

  const { TextArea } = Input

  return (
    <Row style={styles.container}>
      {additionalInfo && (
        <div style={styles.textAreaWrapper as CSSProperties}>
          <div style={styles.additionalInfo}>
            {localisation?.additionalInfo}
          </div>
          <TextArea
            rows={4}
            style={styles.textArea}
            value={additionalInfoValue}
            onChange={textAreaOnChange}
          />
        </div>
      )}
      <MainContainer>
        <NextReview>{localisation?.title}</NextReview>
        <DateContainer>
          <CalendarIcon size={24} name="CalendarOutlined" />
          <InputDatePicker
            disabledDate={disabledDate}
            format={format}
            value={dateValue}
            onChange={datePickerOnChange}
            localization={{
              placeholder: localisation?.datePicker,
              errorMessage: 'Please enter a date!',
            }}
            style={styles.datePicker}
          />
        </DateContainer>
        <InputRadioGroupStyled
          noBorder
          // @ts-ignore
          value={timeValue}
          layout="row"
          options={timeOptions}
          localization={{ errorMessage: 'Please select an option!' }}
          onChange={radioGroupOnChange}
        />
      </MainContainer>
    </Row>
  )
}

export default NextReviewField
